import { render, staticRenderFns } from "./CartDeliveryType.vue?vue&type=template&id=335ea2ed&scoped=true"
import script from "./CartDeliveryType.vue?vue&type=script&lang=js"
export * from "./CartDeliveryType.vue?vue&type=script&lang=js"
import style0 from "./CartDeliveryType.vue?vue&type=style&index=0&id=335ea2ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ea2ed",
  null
  
)

export default component.exports